import type { SVGProps } from "react";

/**
 * Google "G" mark icon (standard 4-color).
 *
 * API mirrors a lucide icon: pass `className` (e.g. `size-4`) and any other
 * SVG props. Shipped locally rather than pulled in as a dependency since it's
 * the only Google asset we need.
 */
export function Google({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path
        fill="#4285F4"
        d="M23.52 12.273c0-.851-.076-1.67-.218-2.455H12v4.64h6.458a5.52 5.52 0 0 1-2.395 3.622v3.011h3.877c2.269-2.089 3.58-5.166 3.58-8.818Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.956-1.075 7.94-2.909l-3.877-3.011c-1.075.72-2.45 1.146-4.063 1.146-3.126 0-5.771-2.111-6.717-4.948H1.28v3.11A11.997 11.997 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.283 14.278a7.198 7.198 0 0 1 0-4.556v-3.11H1.28a11.997 11.997 0 0 0 0 10.776l4.003-3.11Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.773c1.762 0 3.344.606 4.588 1.796l3.441-3.441C17.951 1.19 15.236 0 12 0 7.392 0 3.405 2.638 1.28 6.611l4.003 3.11c.946-2.836 3.591-4.948 6.717-4.948Z"
      />
    </svg>
  );
}
